// extracted by mini-css-extract-plugin
module.exports = {"optimization_custom-content-wrapper":"OptimizationConfig_optimization_custom-content-wrapper__3nGBq","optimization_footer":"OptimizationConfig_optimization_footer__41BZb"};